import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PendingOrdersPage from "../components/pending-orders-page";
import * as actions from "../redux/actions/catalogActions";

const mapStateToProps = (state) => ({
  catalog: state.catalogReducer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PendingOrdersPage);
